import { InternetStatus } from "@/components/commons/InternetStatus";
import { Toast } from "@/components/elements/Toast";
import { queryClient, queryClientNoCache } from "@/constants/queryClient";
import { MaintenanceConsumer, MaintenanceProvider } from "@/providers/MaintenanceProvider";
import { LanguageProvider } from "@/providers/LanguageProvider";
import { LocalizedDateProvider } from "@/providers/LocalizedDateProvider";
import { NativeBridgeProvider } from "@/providers/NativeBridgeProvider";
import { NativeNotificationListener } from "@/components/commons/NativeNotificationListener";
import theme from "@/theme";
import { FCC } from "@/types/common";
import { MAINTENANCE_MODE } from "@/types/enum";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";

// Initialize i18n (must be imported before rendering)
import "@/i18n";

export const AppProvider: FCC = ({ children }) => {
  return (
    <MaintenanceProvider>
      <MaintenanceConsumer>
        {({ data }) => {
          return (
            <QueryClientProvider client={data?.maintenanceMode === MAINTENANCE_MODE.MAINTENANCE_READABLE ? queryClientNoCache : queryClient}>
              <NativeBridgeProvider>
                <LanguageProvider>
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Toast />
                    <LocalizedDateProvider>
                      <NativeNotificationListener />
                      {children}
                    </LocalizedDateProvider>
                    <InternetStatus />
                  </ThemeProvider>
                </LanguageProvider>
              </NativeBridgeProvider>
            </QueryClientProvider>
          );
        }}
      </MaintenanceConsumer>
    </MaintenanceProvider>
  );
};
